import { Icon } from '@sleepstation/components'
import { HLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN } from '@sleepstation/const'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(HLayout).attrs({
  align: LAYOUT_ALIGN.CENTER,
  spacing: 0.3,
  as: `button`,
  'data-cy': `overflow-menu-button`,
})`
  color: white;
  font-size: 18px;
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.25s ease-in-out;

  &:hover {
    color: #f7b85f;
  }
`
const Label = styled.span``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const BurgerMenu = ({ setMenuIsOpen, menuIsOpen }) => (
  <Layout onClick={() => setMenuIsOpen(!menuIsOpen)}>
    <Label>Menu</Label>
    <Icon name={menuIsOpen ? `closeMenu` : `openMenu`} />
  </Layout>
)

BurgerMenu.propTypes = {
  menuIsOpen: PropTypes.bool.isRequired,
  setMenuIsOpen: PropTypes.func.isRequired,
}

export default BurgerMenu
